import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { M } from "./tokens";

export function useModalChrome(onClose) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);
}

export function FullScreenEmbed({ route, label, onClose }) {
  useModalChrome(onClose);
  return createPortal(
    <div
      className="fixed inset-0 z-[1000]"
      style={{ background: "rgba(4,5,7,0.88)", backdropFilter: "blur(6px)" }}
      data-testid="ops-fullscreen-modal"
      onClick={onClose}
    >
      <div
        className="mx-auto mt-[4vh] flex h-[92vh] w-[min(1140px,94vw)] flex-col overflow-hidden rounded-2xl border"
        style={{ borderColor: M.border, background: M.surface }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 border-b px-4 py-3" style={{ borderColor: M.border, background: M.surface2 }}>
          <span className="h-2 w-2 rounded-full" style={{ background: M.ok, boxShadow: `0 0 8px ${M.ok}` }} />
          <span className="f-mono min-w-0 flex-1 truncate text-[9.5px] uppercase tracking-[0.16em]" style={{ color: M.muted }}>{label}</span>
          <Link
            to={`${route}?tests=1`}
            data-testid="ops-fullscreen-walk"
            className="focus-ring f-mono shrink-0 rounded px-3 py-1.5 text-[9px] font-semibold uppercase tracking-[0.12em]"
            style={{ background: M.ok, color: "#04170F" }}
          >
            Walk it with the tests
          </Link>
          <button
            onClick={onClose}
            data-testid="ops-fullscreen-close"
            aria-label="Close full screen"
            className="focus-ring shrink-0 rounded p-1.5"
            style={{ border: `1px solid ${M.border}`, color: M.ink }}
          >
            <X size={14} />
          </button>
        </div>
        <iframe title={label} src={`${route}?embed=1`} className="w-full flex-1" style={{ border: 0, background: "#FDFBF7" }} />
      </div>
    </div>,
    document.body
  );
}
